import { Component, ElementRef, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base-components/base.component';

@Component({
    selector: 'user-assistance-panel',
    templateUrl: './help-panel.html'
})

export class HelpPanelComponent extends BaseComponent {
    public productVersion: string;
    private keywordField: string;
    public results: any[] = new Array();
    @ViewChild('helpContentFrame', { static: true }) _helpContentFrame: ElementRef;

    constructor() {
        super();
        var self = this;

        this.helpCommunicationService.helpLinkClicked$.subscribe((x) => {
            self.navigationEvent.call(self, x);
        });
    }

    ngOnInit() {
        this.productVersion = this.helpCommunicationService.getProductVersion();
    }

    navigationEvent(url: string, $event: any) {
        if ($event) {
            $event.preventDefault();
        }

        this._helpContentFrame.nativeElement.src = url;
    }

    closePanel() {
        this.helpCommunicationService.emitClosePanelEvent();
    }
}
